import { render, staticRenderFns } from "./problemDetail.vue?vue&type=template&id=39bf9cb7&scoped=true&"
import script from "./problemDetail.vue?vue&type=script&lang=js&"
export * from "./problemDetail.vue?vue&type=script&lang=js&"
import style0 from "./problemDetail.vue?vue&type=style&index=0&id=39bf9cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf9cb7",
  null
  
)

export default component.exports